import { render, staticRenderFns } from "./Beneficiarios.vue?vue&type=template&id=a6c788e4&scoped=true"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"
import style0 from "./Beneficiarios.vue?vue&type=style&index=0&id=a6c788e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c788e4",
  null
  
)

export default component.exports